import { useState } from 'react';

export const useLocalStorage = (keyName) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return value;
      }
    } catch (err) {
      return err;
    }
  });
  const setValue = (newValue) => {
    try {
      if (newValue === null || newValue === undefined) {
        window.localStorage.removeItem(keyName);
        setStoredValue(null);
        return;
      }
      window.localStorage.setItem(keyName, newValue);
    } catch (err) {
      console.log(err);
    }
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};
